import { addHours, setMinutes, setSeconds, setMilliseconds, parseISO } from "date-fns"
import type { CustomEvent, DailyCalendarEvent } from "../entities/daily-calendar"

export default function getCustomEvents(filteredEvents: DailyCalendarEvent[]): CustomEvent[] {
  const customEvents: CustomEvent[] = []

  filteredEvents.forEach((event) => {
    if (event.dailyCalendarEventType === "exceeded") return

    if (event.dailyCalendarEventType === "event") {
      customEvents.push({
        ...event,
        start: new Date(event.startDate),
        end: new Date(event.endDate),
      })
    } else {
      if (!event.dateTime || !event.estimatedDuration) return

      const dateTimeObj = parseISO(event.dateTime)
      const startDate = setMilliseconds(setSeconds(setMinutes(dateTimeObj, 0), 0), 0)

      const [hours, minutes, seconds] = event.estimatedDuration.split(":").map(Number)
      const realEndDate = addHours(dateTimeObj, hours)
      realEndDate.setMinutes(realEndDate.getMinutes() + minutes)
      realEndDate.setSeconds(realEndDate.getSeconds() + seconds)

      const roundedEndDate = addHours(startDate, 1)

      if (realEndDate <= roundedEndDate) {
        customEvents.push({
          ...event,
          start: startDate,
          end: roundedEndDate,
        })
      } else {
        customEvents.push({
          ...event,
          id: `${event.id}-1`,
          start: startDate,
          end: roundedEndDate,
        })

        const secondStartDate = new Date(roundedEndDate)
        const secondEndDate = addHours(secondStartDate, 1)

        customEvents.push({
          ...event,
          id: `${event.id}-2`,
          start: secondStartDate,
          end: secondEndDate,
        })
      }
    }
  })

  return customEvents
}
